import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
    selectSeatingByHashAndType,
} from '%paysera_seat_selection_integration/js/seatings/redux/components/orm/selectors';
import SeatingCartItem from './SeatingCartItem';

const styles = ({ palette, transitions }) => ({
    icon: ({ ticketTypeColor }) => {
        if (ticketTypeColor === null) {
            return palette.grey[50];
        }

        return {
            backgroundColor: ticketTypeColor,
        };
    },
    item: {
        '&:hover': {
            backgroundColor: palette.grey[200],
            transition: transitions.create(['background-color'], { duration: transitions.duration.complex }),
        },
    },
});

export default compose(
    connect(
        (
            state,
            {
                item: {
                    seating: { type, hash },
                },
            },
        ) => ({
            seatingModel: selectSeatingByHashAndType(state, hash, type),
        }),
    ),
    withStyles(styles),
)(SeatingCartItem);
